export const MoneyFormatter = Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
  });
